// extracted by mini-css-extract-plugin
export var section = "_2y-1";
export var topNav = "_2y-0";